import {createContext} from 'react';
import {DocumentListType, I9DocumentType, IDocument, WorkStatus} from '@models/onboarding-review/section2-document-upload';

export interface DocumentUploadState {
  documentList: Map<DocumentListType, IDocument[]>;
  setDocumentList: (documentList: Map<DocumentListType, IDocument[]>) => void;
  documentListType: DocumentListType;
  setDocumentListType: (documentListType: DocumentListType) => void;
  workStatus: WorkStatus | undefined;
  filteredDocuments: I9DocumentType[];
  setFilteredDocuments: (documents: I9DocumentType[]) => void;
}

export const DocumentUploadContext = createContext<DocumentUploadState | null>(null);

if (process.env.NODE_ENV !== 'production') {
  DocumentUploadContext.displayName = 'DocumentUploadPageContext';
}



// WEBPACK FOOTER //
// ./src/contexts/DocumentUploadState.ts